<template>
  <div @mouseleave="showCityPopup = false" class="country-info-wrapper">
    <span @mouseleave="showCityPopup = false" class="client-country">
      <span
        @click="
          $emit('edit');
          showCityPopup = false;
        "
      >
        <span @mouseover="showCityPopup = true" v-if="client.lead_loc">{{
          client.lead_loc | truncate(11)
        }}</span></span
      >
    </span>

    <div v-if="showCityPopup" class="country-area-popup">
      <!--  {{ cityName }}-->
      {{ client.loc_physical_ms }} |
      <span v-if="client.lead_loc">{{ client.lead_loc }}</span>
    </div>
  </div>
</template>

<script>
import apiClientCreator from "../../../../../helpers/api/request";

export default {
  name: "ClientCountyInfo",

  props: {
    client: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      showCityPopup: false,
      cityName: null
    };
  },
  methods: {
    prepareMap() {
      this.getGeoCode();
    },
    async getGeoCode() {
      // this.$store.commit("clients/setLoading", true);
      // let locPhisMs;
      // if (this.client.loc_physical_ms === null) {
      //   locPhisMs = "";
      // } else {
      //   const reqCriteria = apiClientCreator(
      //     `client/city/${this.client.loc_physical_ms}`
      //   );
      //   reqCriteria.get("").then(locPhisMs => {
      //     if (locPhisMs.data) {
      //       this.cityName = locPhisMs.data[0];
      //       this.showCityPopup = true;
      //     }
      //     this.$store.commit("clients/setLoading", false);
      //   });
      // }
      this.cityName = this.client.lead_loc;
      this.showCityPopup = true;
    }
  }
};
</script>

<style scoped>
.country-info-wrapper {
  position: relative;
  font-family: "Montserrat" !important;
  font-size: 9px;
  text-transform: uppercase;
}

.country-area-popup {
  position: absolute;
  padding: 8px;
  top: 24px;
  left: 0px;
  z-index: 10001;
  border: solid 1px #90a4ae;
  width: max-content;
  border-radius: 5px;
  background-color: #fff;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  font-size: 12px;
}

.country-map {
  position: absolute;
  padding: 8px;
  bottom: 10px;
  left: 0px;
  z-index: 10001;
  border: solid 1px #90a4ae;
  width: max-content;
  height: max-content;
  border-radius: 5px;
  background-color: #fff;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  font-family: Montserrat !important;
}

.client-country {
  margin-left: 2px;
  cursor: pointer;
  font-size: 12px !important;
}

.country-flag {
  margin-top: -3px;
  margin-left: 5px;
}

.country-clock {
  font-size: 8pt;
  margin-left: 5px;
}
</style>
